export default "__VITE_ASSET__lBaQ3UMx__"